import { FC } from "react";
import { Messages, SplitText } from "./Loading";
import { Loader } from "./Loader";
import { motion } from "motion/react";

export const LoaderWithMessages: FC = () => {
  const rand = Math.round(Math.random() * Messages.length);
  return (
    <div className="rujira__main flex ai-c jc-c dir-c">
      <Loader className="w-10 h-10" />
      <motion.div
        className="mt-2"
        initial={{ opacity: 1 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}>
        <SplitText
          initial={{ y: "100%" }}
          animate="visible"
          variants={{
            visible: (i: number) => ({
              y: 0,
              transition: {
                delay: i * 0.025,
              },
            }),
          }}>
          {Messages[rand] + "..."}
        </SplitText>
      </motion.div>
    </div>
  );
};
